import React, { useRef } from 'react'
import Lottie, { LottieRefCurrentProps } from 'lottie-react'
import WMGLogo from 'assets/animatedIcons/loadMoreLogo.json'

export const Spinner: React.FC = () => {
  const lottieRef = useRef<LottieRefCurrentProps | null>(null)

  return (
    <div id={'spinner-container'} style={{
      height: '100vh',
      width: '100vw',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <Lottie lottieRef={lottieRef} animationData={WMGLogo} loop={true} style={{
        aspectRatio: '650/320',
        maxWidth: 200
      }}
      />
    </div>

  )
}
